import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import { useGetAllPlacesList } from "../../Parameters/Geographicals/Places/api/getAllPlacesList";
import { useGetAllModemsList } from "../../Parameters/Equipment/Modems/api/getAllModemsList";
import FormikTextbox from "src/components/Common/UI/Formik/FormikTextbox";
import FormikDropdown from "src/components/Common/UI/Formik/FormkDropdown";
import FormikCheckbox from "src/components/Common/UI/Formik/FormikCheckbox";


const DepartmentEditForm = ({ initialValues, onSubmit }: CreateOrEditProps) => {
    const { t } = useTranslation();

    const getAllPlacesListQuery = useGetAllPlacesList();
    const getAllModemsListQuery = useGetAllModemsList();
    
    const validationSchema= Yup.object({
      description:Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
      unID:Yup.string().required('Το πεδίο είναι υποχρεωτικό')
    })

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSubmit(values, formikHelpers);
        }}
        validationSchema={validationSchema}
      >
        {({ errors, touched, isSubmitting, values, getFieldProps }) => (
          <Form>
            <Container fluid className="p-0">
              <Row>
                <Col xs={6}>
                  <FormikTextbox 
                    label={`${t("Ονομασία")}*`} 
                    fieldName={"description"}                
                  />
                </Col>

                <Col xs={6}>
                  <FormikDropdown 
                    label={t("Τοποθεσία")} 
                    fieldName={"placeID"} 
                  >
                    <option value="">{t("Επιλέξτε Τοποθεσία")}</option>
                    {getAllPlacesListQuery.data &&
                      getAllPlacesListQuery.data.map((place) => (
                        <option key={place.id} value={place.id}>
                          {place.name}
                        </option>
                      ))
                    }
                  </FormikDropdown>
                </Col>

                <Col xs={6} className="d-none">
                  <FormikDropdown 
                    label={t("Modem")} 
                    fieldName={"modemID"} 
                  >
                    <option value="">{t("Επιλέξτε Modem")}</option>
                    {getAllModemsListQuery.data &&
                      getAllModemsListQuery.data.map((modem) => (
                        <option key={modem.id} value={modem.id}>
                          {modem.description}
                        </option>
                      ))
                    }
                  </FormikDropdown>
                </Col>

                <Col xs={6} className="d-none">
                  <FormikTextbox 
                    label={`${t("Θύρα Modem")}`} 
                    fieldName={"modemPort"}                
                  />
                </Col>

                <Col xs={6}>
                  <FormikTextbox 
                    label={`${t("Κωδικός Διεύθυνσης")}*`} 
                    fieldName={"unID"}                
                  />
                </Col>
                
                <Col xs={6}>
                  <FormikTextbox 
                    label={`${t("Κωδικός SAP")}`} 
                    fieldName={"sapCode"}                
                  />
                </Col>
          
                <Col xs={6}>
                  <FormikCheckbox 
                    label={`${t("Εμπορική")}`} 
                    fieldName={"isEmporiki"} 
                  />
                </Col>

                <Col xs={6}>
                  <FormikCheckbox 
                    label={`${t("Citibank")}`} 
                    fieldName={"isCity"} 
                  />
                </Col>

              </Row>
            </Container>

            <div className="mb-3">
              <Button
                type="submit"
                size="sm"
                styletype="primary"
                disabled={isSubmitting}
              >
                {t("Δημιουργία")}
              </Button>
            </div>
          </Form>
      )}
      </Formik>
  )
}

export default DepartmentEditForm;

type CreateOrEditProps = {
  initialValues: ICreateDepartmentForm;
  onSubmit: (
    values: ICreateDepartmentForm,
    formikHelpers: FormikHelpers<ICreateDepartmentForm>
  ) => void;
}